import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var SSRPlaceholderHandlers = /*#__PURE__*/function () {
  function SSRPlaceholderHandlers() {
    var _this = this;
    _classCallCheck(this, SSRPlaceholderHandlers);
    _defineProperty(this, "staticPlaceholders", new Map());
    _defineProperty(this, "callbacks", new Map());
    _defineProperty(this, "getSizeCallbacks", new Map());
    _defineProperty(this, "reactValidateCallbacks", new Map());
    _defineProperty(this, "intersectionObserverCallback", function (_ref) {
      var target = _ref.target,
        boundingClientRect = _ref.boundingClientRect;
      _this.intersectionObserver.unobserve(target);
      if (!(target instanceof HTMLElement)) {
        // impossible case - keep typescript healthy
        return;
      }
      var staticKey = target.dataset.ssrPlaceholder || '';
      if (staticKey) {
        if (_this.staticPlaceholders.has(staticKey) && _this.callbacks.has(staticKey)) {
          // validation
          var _resolve = _this.callbacks.get(staticKey);
          if (!_resolve) {
            return;
          }
          var rect = _this.staticPlaceholders.get(staticKey);
          var hasSameSizePosition = rect && rect.x === boundingClientRect.x && rect.y === boundingClientRect.y && rect.width === boundingClientRect.width && rect.height === boundingClientRect.height || false;
          _resolve(hasSameSizePosition);
          _this.callbacks.delete(staticKey);
        } else {
          // initial check
          _this.setSizeOfStaticElement(target, boundingClientRect);
        }
      } else {
        // react component check
        var key = target.dataset.ssrPlaceholderReplace || '';
        var _resolve2 = _this.reactValidateCallbacks.get(key);
        if (!_resolve2) {
          return;
        }
        var _rect = _this.staticPlaceholders.get(key);
        var _hasSameSizePosition = _rect && _rect.x === boundingClientRect.x && _rect.y === boundingClientRect.y && _rect.width === boundingClientRect.width && _rect.height === boundingClientRect.height || false;
        _resolve2(_hasSameSizePosition);
        _this.staticPlaceholders.delete(staticKey);
        _this.reactValidateCallbacks.delete(staticKey);
      }
    });
    this.intersectionObserver = new IntersectionObserver(function (entries) {
      return entries.forEach(_this.intersectionObserverCallback);
    });
    if (window.document) {
      try {
        var existingElements = document.querySelectorAll('[data-ssr-placeholder]');
        existingElements.forEach(function (el) {
          var _el$dataset;
          if (el instanceof HTMLElement && el !== null && el !== void 0 && (_el$dataset = el.dataset) !== null && _el$dataset !== void 0 && _el$dataset.ssrPlaceholder) {
            _this.staticPlaceholders.set(el.dataset.ssrPlaceholder, {
              width: -1,
              height: -1,
              x: -1,
              y: -1
            });
            _this.intersectionObserver.observe(el);
          }
        });
      } catch (e) {}
    }
  }
  _createClass(SSRPlaceholderHandlers, [{
    key: "clear",
    value: function clear() {
      this.staticPlaceholders = new Map();
      this.callbacks = new Map();
      this.getSizeCallbacks = new Map();
      this.reactValidateCallbacks = new Map();
    }
  }, {
    key: "isPlaceholder",
    value: function isPlaceholder(element) {
      return !!element.dataset.ssrPlaceholder;
    }
  }, {
    key: "isPlaceholderReplacement",
    value: function isPlaceholderReplacement(element) {
      return !!element.dataset.ssrPlaceholderReplace;
    }
  }, {
    key: "checkIfExistedAndSizeMatching",
    value: function checkIfExistedAndSizeMatching(el) {
      var _this2 = this;
      var id = el.dataset.ssrPlaceholder || '';
      return new Promise(function (resolve) {
        if (!_this2.staticPlaceholders.has(id)) {
          resolve(false);
          return;
        } else {
          _this2.callbacks.set(id, resolve);
          _this2.intersectionObserver.observe(el);
        }
      });
    }
  }, {
    key: "getSize",
    value: function getSize(el) {
      var _this3 = this;
      return new Promise(function (resolve) {
        _this3.getSizeCallbacks.set(el.dataset.ssrPlaceholder || '', resolve);
        _this3.intersectionObserver.observe(el);
      });
    }
  }, {
    key: "setSizeOfStaticElement",
    value: function setSizeOfStaticElement(el, boundingClientRect) {
      var key = el.dataset.ssrPlaceholder || '';
      var entry = this.staticPlaceholders.get(key);
      if (!entry) {
        return;
      }
      this.staticPlaceholders.set(key, {
        x: boundingClientRect.x,
        y: boundingClientRect.y,
        width: boundingClientRect.width,
        height: boundingClientRect.height
      });
    }
  }, {
    key: "validateReactComponentMatchToPlaceholder",
    value: function validateReactComponentMatchToPlaceholder(el) {
      var _this4 = this;
      var id = el.dataset.ssrPlaceholderReplace || '';
      return new Promise(function (resolve) {
        if (!_this4.staticPlaceholders.has(id)) {
          resolve(false);
          return;
        } else {
          _this4.reactValidateCallbacks.set(id, resolve);
          _this4.intersectionObserver.observe(el);
        }
      });
    }
  }]);
  return SSRPlaceholderHandlers;
}();